<mat-expansion-panel expanded="true">
    <mat-expansion-panel-header class="flex flex-col gap-2">
        <mat-panel-title>
            <div class="flex flex-row items-center justify-between">
                <fa-icon
                    class="mr-4"
                    matPrefix
                    size="lg"
                    [class]="statusesIconsProperties[interventionsByStatus().name].color"
                    [icon]="statusesIconsProperties[interventionsByStatus().name].icon" />
            </div>

            <span class="text-xl font-medium leading-tight text-black"
                >{{
                    translatedStatusKey() | transloco: { COUNT: interventionsByStatus().fieldInterventions.length }
                }}
                ({{ interventionsByStatus().fieldInterventions.length }})</span
            >
        </mat-panel-title>
    </mat-expansion-panel-header>
    @for (intervention of interventionsByStatus().fieldInterventions; track intervention) {
        <div class="pb-2">
            <div
                class="intervention transition ease-in-out duration-200 rounded text-base font-normal cursor-pointer pl-6"
                [class.pointer-events-none]="isOpeningFieldIntervention()"
                (click)="openFieldInterventionDetail(intervention)">
                <span class="transition ease-in-out duration-200 text-base">{{ intervention.name }}</span>
            </div>
        </div>
    }
</mat-expansion-panel>
